/**
 * URL에서 파일명 추출
 * @param url - 파일 URL
 * @returns 추출된 파일명 또는 빈 문자열
 */
export function getFilenameFromUrl(url: string | undefined): string {
  if (!url) return '';
  if (!url.includes('/')) return url;
  return url.split('/').pop() ?? '';
}
